import { coreCustomersByIdFeatureFlagsGetSlice } from './get';

export const {
	requestGetCoreCustomersByIdFeatureFlags,
	resetGetCoreCustomersByIdFeatureFlags
} = coreCustomersByIdFeatureFlagsGetSlice.asyncActionCreators;
